import type { ReactNode } from 'react';

import { legalFooterLinks, productFooterLinks } from '../data/footerLinks';

type PageChromeProps = {
  children: ReactNode;
  nav?: ReactNode;
};

export function PageChrome({ children, nav }: PageChromeProps) {
  return (
    <div className="page-shell">
      <PageHeader nav={nav} />
      {children}
      <PageFooter />
    </div>
  );
}

export function PageHeader({ nav }: { nav?: ReactNode }) {
  return (
    <header className="page-header">
      <div className="section-inner page-header-inner">
        <a href="/" className="page-back-link">
          <ArrowLeftIcon />
          Vissza
        </a>
        <a href="/" className="brand-link page-brand-link" aria-label="Orienta főoldal">
          <LogoMark />
          <span>Orienta</span>
        </a>
        <div className="page-header-nav">{nav}</div>
      </div>
    </header>
  );
}

export function PageFooter() {
  return (
    <footer className="page-footer">
      <div className="section-inner page-footer-inner">
        <p>© 2026 Orienta. Minden jog fenntartva.</p>
        <nav className="page-footer-columns" aria-label="Lábléc navigáció">
          <div>
            <h2>Termék</h2>
            {productFooterLinks.map((link) => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </div>
          <div>
            <h2>Jogi &amp; bizalom</h2>
            {legalFooterLinks.map((link) => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </div>
        </nav>
      </div>
    </footer>
  );
}

export function LogoMark() {
  return (
    <svg className="logo" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <circle cx="16" cy="16" r="14.4" stroke="currentColor" strokeWidth="1.2" opacity=".45" />
      <path d="M16 4.6 L18.7 16 L16 27.4 L13.3 16 Z" fill="var(--accent)" />
      <path d="M4.6 16 L16 13.3 L27.4 16 L16 18.7 Z" fill="currentColor" opacity=".75" />
      <circle cx="16" cy="16" r="1.7" fill="var(--paper)" />
    </svg>
  );
}

function ArrowLeftIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M13 8H4M7 4L3 8l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
